// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_tracking_ui_styles" + "." + "0a7969c5" + ".chunk.css";
};